// extracted by mini-css-extract-plugin
module.exports = {"qcSubmissionTable":"QCFormSubmission_qcSubmissionTable__12lpG","actions":"QCFormSubmission_actions__3CcTl","pl10":"QCFormSubmission_pl10__1pbh0"};